import { TemplateId } from "src/globalTypes";
import { LinkData } from "../../../../../../requests/templates/types";
import { getDetailTableRowURL } from "../../../../../../utils/internalLinksParsing";

export const parseDetailLink = (
  value: string,
  overviewId?: TemplateId | null,
  templateItemId?: number
): string => {
  try {
    const linkData = JSON.parse(value) as LinkData;
    const { templateId, rowKeyValue } = linkData;
    return getDetailTableRowURL({
      templateId,
      rowKeyValue,
      overviewId,
      templateItemId,
    });
  } catch (e) {
    return "";
  }
};

export const parseLinkValue = (value: string) => {
  let linkData = null;
  try {
    linkData = JSON.parse(value) as LinkData;
  } catch (e) {
    return "Incorrect value format";
  }
  return linkData?.value ?? "";
};
